var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21660_191945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26659 13.3347C6.53897 13.9874 8.00264 14.1642 9.39384 13.8332C10.785 13.5022 12.0123 12.6852 12.8544 11.5295C13.6966 10.3737 14.0982 8.95514 13.987 7.52944C13.8758 6.10374 13.259 4.76465 12.2478 3.75346C11.2366 2.74228 9.89751 2.1255 8.47181 2.01428C7.04611 1.90305 5.62757 2.3047 4.4718 3.14683C3.31603 3.98896 2.49905 5.21621 2.16807 6.60741C1.83709 7.99861 2.01388 9.46228 2.66659 10.7347L1.33325 14.668L5.26659 13.3347Z",
    stroke: "#15C7A7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21660_191945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9787668f54f666fdb28a3cbc8f4ad886.svg";
export { ForwardRef as ReactComponent };